module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap_section"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("hile the Luftwaffe had enjoyed an almost uninterrupted succession of military triumphs from 1939, during the autumn and winter of 1942 its fate changed: the battle of El Alamein and the Allied landings in North Africa sealed its fate on that continent, while its offensive in the USSR – aimed at seizing the oilfields of the Caucasus – ended with the Stalingrad disaster in early 1943. Though the Luftwaffe was a force to be reckoned with during the early years of the Second World War, German aviation was now forced onto the defensive. In the East, the Wehrmacht’s last offensive – the battle of Kursk of July–August 1943 – was thwarted by the might of the Soviet forces, which continued to advance towards the Reich. In the south, the Allied landings in Sicily (July 1943) and Italy (September 1943) forced the Germans to withdraw north up the peninsula. To rub salt in the wounds, Mussolini was overthrown, and parts of the Italian army were now taking up arms against their former allies. Finally, in the West, the British and Americans had begun to break the back of their adversary with large, extended air raids, paralyzing Germany’s economy and reducing the Luftwaffe’s available resources to negligible proportions. On June 6th, 1944 the massive D-Day landings in Normandy commenced, followed by further landings in Provence in the south of France. On June 22nd, on the Eastern Front, the Soviets launched Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bagration")]), _vm._v(" that liberated Belarus in just weeks, and resulted in the occupation of East Prussia and Poland up to the Vistula. It was the beginning of the end for the Luftwaffe. Though it had been the first in the world to use jet engines, therefore ushering in a new era of “modern aviation”, the Luftwaffe agonized. It only survived four months after Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bodenplatte")]), _vm._v(", a futile, last-gasp offensive launched on January 1st, 1945 against the Allied air forces in the West. But its airmen fought on regardless, with a dignified courage that was worthy of their beginnings.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("The authors would like to thank everyone who helped them realize this study in colour of the Luftwaffe during the Second World War, especially the Finnish researcher Matti Salonen, without whom this work would never have been completed. Thanks also to Dénes Bernad, Josef Charita, Jean-Marie Gall, Giancarlo Garello, Roberto Gentilli, Bohumir Kudlicka, Michel Ledet, Jacques Moulin, Philippe Ricco, Philippe Saintes, Kari Stenmann, and anyone else whom they might have inadvertently overlooked.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("1./JG 1’s Bf 109 E-4 (or E-7) “Black 11” at Flushing in the Netherlands, during the winter of 1940–1941. In the second image we can see Sergeant Giuseppe Ruzzin of the 85th Squadron (one of the Corpo Aereo Italiano squadrons that attacked England) posing with Obfw Werner Gerhardt. Note the unusual Plexiglas casing under the fuselage of the Messerschmitt – this houses a Peilgerät IV radio guidance device. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Roberto Gentilli collection)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0008-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A relaxed atmosphere prior to take-off for this training plane, an Arado Ar 96 painted in two shades of green.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capr"
  }, [_vm._v("A Ju 88 D-1 from 2. (F)/123 is refuelled by an Opel Kfz 385 tanker in Sicily in the spring of 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capr"
  }, [_vm._v("Early 1941: Armourers carrying 50kg SC50 bombs in front of a Junkers Ju 87 B-1 on the Channel coast. These photographs are part of the same series found on "), _c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter_1#pg42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 42")]), _vm._v(" of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Luftwaffe in Colour: The Victory Years")]), _vm._v(". The Stuka seen here belonged to the 2nd squadron (or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("staffel")]), _vm._v(") of an unknown group; we know this from its black and red colouring. The 1st squadron used white, and the 3rd blue.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Saint-Jean-d’Angély, early 1941: This old twin-engined French reconnaissance plane, the Potez 63-11, served as a decoy aircraft for the operations training squadron 2. (Erg.)/JG 53. In the background, armed with four machine guns, is Bf 109 E-8/B (W.Nr. 1237) “15 Black” which was seriously damaged on March 17th, 1941 – just weeks after this photograph was taken – when its engines failed during landing. Despite being approximately 75% damaged, this plane (curiously armed with wing-guns like an E-3) was repaired, upgraded to an E-7 and put back into action at the beginning of 1942 in 2./JG 51 on the Soviet Front. It was then transferred to III./ZG 1 in Africa, where it was lost without a trace after an accident during take-off from Bir el Abd, Egypt, on September 14th, 1942. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Philippe Ricco collection)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hptm Walter Oesau, commander of III./JG 3, photographed on July 12th, 1941 in Polonne, Ukraine, registering seven kills in one day. The bare-headed man wearing sunglasses in the centre is Fw Georg Schentke, who himself claimed five kills that day. Though he was wounded 12 days later when claiming his 86th victim, “Gulle” Oesau figured amongst the great aces of Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barbarossa")]), _vm._v(", during which he reported 44 victories in less than a month and a half.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("This Ar 96 B-1, seen here taking off in Norway, is GA+NH (W.Nr. 960037) of Verbindungstaffel 2. It was severely damaged during a forced landing near Stavanger on October 10th, 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0011-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Ju 88 A-4 F1+DD of Stab III./KG 76 in flight over the Soviet Union in early winter 1941. The tips of the propeller cones are painted in the colours of the group’s three squadrons: white (7th), red (8th) and yellow (9th). This transport had just been transferred to 9. Staffel (W.Nr. 088 1340), but was damaged by ground fire 30 kilometres north of Moscow on November 30th, 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Two Bf 110 fighter-bombers of 5./SKG 210 preparing to take off on the Eastern Front in early autumn 1941. The wasp symbolizing their squadron (see also "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Luftwaffe in Colour: The Victory Years")]), _vm._v(", pages 93 and 101) has been removed from the noses. These planes are possibly E-2N S9+HN (W.Nr. 4415), which disappeared south of Demidov on February 11th, 1942, and E-1/N S9-IN (W.Nr. 4053), seen next, that went missing south-east of Suchinitschi, near Bryansk on February 28th, 1942 after taking fire in combat. Their squadron became the 5./ZG 1 at that time. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Roberto Gentilli collection)")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-03.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("Oblt Max-Hellmuth Ostermann of 3./JG 54 received the Knight’s Cross with oak leaves (RK-E) on March 12th, 1942 for his 62nd aerial victory. Ostermann was shot down and killed by an LaGG-3 the following August 9th, with a total of 102 kills.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-04.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "capl"
  }, [_vm._v("The vertical tailfin of FW 190 A-2 + – (W.Nr. 20209), flown by Hptm Joachim Müncheberg, commander of II./JG 26, adorned with 67 kill bars, in mid-April 1942. It became “Black 7” of 2./JG 110 training squadron, but was destroyed on November 13th, 1944 near Lautenhain.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebfdecfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Introduction.vue
// module id = 78
// module chunks = 0